import { useSessionStore } from '@/stores/SessionStore.ts';

export const handleRequestDesktopAppVersionResponseAction = async (version: string) => {
    const sessionSettingsStore = useSessionStore();
    sessionSettingsStore.desktopAppVersion = version;
};
